module.exports = __webpack_public_path__ + "static/50-49c062ce65bde8342c8adf03806dffde.png";